import React, { Fragment } from 'react';

import { useVersionMigration } from 'app/developer-v3/hooks';

import Progress from './Progress';
import Start from './Start';
import Title from '../Title';

import type { Props as SubsectionProps } from '../Subsection';

type Props = Omit<SubsectionProps, 'sectionId'>;

function Migrate({ integrationId, sectionContext }: Props) {
  const { isLoading, isMigrating, job } = useVersionMigration(integrationId);

  return (
    <Fragment>
      <Title>Migrate Users' Zaps from One Version to Another</Title>
      {isMigrating ? (
        <Progress
          currentStep={job.currentStep}
          progress={job.progress}
          stage={job.stage}
        />
      ) : (
        <Start
          initialFromVersion={sectionContext.fromVersion}
          integrationId={integrationId}
          isLoading={isLoading}
        />
      )}
    </Fragment>
  );
}

export default Migrate;
